
import { Loading, Notification } from 'element-ui'
import axios from 'axios'
import qs from 'qs'

// axios.interceptors.request.use(config => {
//   if (config.method == 'post') {
//     config.data = {
//       data: config.data,
//       _t: Date.parse(new Date().getTime()) / 1000
//     }
//   } else if (config.method == 'get') {
//     config.params = {
//       _t: Date.parse(new Date().getTime()) / 1000,
//       ...config.params
//     }
//   }
//   return config
// })
axios.interceptors.response.use(function(response) {
  if(response.data.status === false) {
    Notification.error({title: '错误', message: response.data.remark, duration: 2000})
  }
  // 对响应数据做点什么
  return response;
}, function(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';
        break;
      case 401:
        err.message = '未授权，请重新登录(401)';
        break;
      case 403:
        err.message = '拒绝访问(403)';
        break;
      case 404:
        err.message = '请求出错(404)';
        break;
      case 408:
        err.message = '请求超时(408)';
        break;
      case 500:
        err.message = '服务器错误(500)';
        break;
      case 501:
        err.message = '服务未实现(501)';
        break;
      case 502:
        err.message = '网络错误(502)';
        break;
      case 503:
        err.message = '服务不可用(503)';
        break;
      case 504:
        err.message = '网络超时(504)';
        break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';
        break;
      default:
        err.message = `连接出错(${err.response.status})!`;
    }
  } else {
    err.message = '连接服务器失败!'
  }
  Notification.error({title: '错误', message: err.message, duration: 0})
  return Promise.reject(err);
});


// 监控设置显示
export function GetMediaEmailList (params) {
  let loadingInstance = Loading.service({
    text: '加载中,请稍后...'
  })
  return axios.get(`/IAD_MediaEmail/List?_t=${new Date().getTime()}`)
    .then(res => {
      loadingInstance.close()
      return Promise.resolve(res.data)
    }).catch(err => {
      loadingInstance.close()
      return Promise.reject(err)
    })
}
// 监控设置保存
export function SaveMediaEmailList(param) {
  let loadingInstance = Loading.service({
    text: '加载中,请稍后...'
  })
  return axios.post(`/IAD_MediaEmail/Save?_t=${new Date().getTime()}`, param)
  .then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  }).catch(err => {
    loadingInstance.close()
    return Promise.reject(err)
  })
}




// WEBPACK FOOTER //
// ./src/api/settingSystem.js